import { render, staticRenderFns } from "./BodyImage.vue?vue&type=template&id=42268eca&scoped=true&lang=pug"
import script from "./BodyImage.vue?vue&type=script&lang=ts"
export * from "./BodyImage.vue?vue&type=script&lang=ts"
import style0 from "./BodyImage.vue?vue&type=style&index=0&id=42268eca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42268eca",
  null
  
)

export default component.exports